interface StorageItem {
  value: string;
  expiresOn: number;
}

export default class Storage {
  static STORAGE_KEYS_PREFIX = 'DOC-';

  static getItem(key: string) {
    if (typeof window === 'undefined') return;
    const item = JSON.parse(localStorage.getItem(`${Storage.STORAGE_KEYS_PREFIX}${key}`)) as StorageItem;
    if (item?.expiresOn && Date.now() > item.expiresOn) {
      localStorage.removeItem(key);
      return null;
    }

    return item?.value ?? null;
  }

  static setItem(key: string, value: string, ttl?: number) {
    if (typeof window === 'undefined') return;
    return localStorage.setItem(
      `${Storage.STORAGE_KEYS_PREFIX}${key}`,
      JSON.stringify({ value, expiresOn: ttl ? Date.now() + ttl : null })
    );
  }

  static clear() {
    localStorage.clear();
  }
}
